// Public asset URLs (uploaded artifacts)
export const ASSETS = {
  skull: "https://sekaitensei.nextworlds.com/picts/skull.png",
  nozora: "https://sekaitensei.nextworlds.com/picts/nozora.png",
  cartridgeLabel: "https://sekaitensei.nextworlds.com/picts/label.png",
  videos: {
    en: "https://sekaitensei.nextworlds.com/vids/SekaiTenseiPromoVideoEN_v1.mov",
    fr: "https://sekaitensei.nextworlds.com/vids/SekaiTenseiPromoVideoFR_v1.mov",
    es: "https://sekaitensei.nextworlds.com/vids/SekaiTenseiPromoVideoSP_v1.mov",
  },
};

export const SHOP_URL = "https://shop.nextworlds.com";
